const pricingTier = {
  1: {
    amount: "99",
    nextTier: "5-14",
    nextTierAmount: "79",
  },
  2: {
    amount: "79",
    nextTier: "15+",
    nextTierAmount: "59",
  },
  3: {
    amount: "59",
  },
};

const pricing2025 = {
  GROWTH: {
    label: "Growth",
    price: 149,
    value: "GROWTH",
  },
  BASIC: {
    label: "Basic",
    price: 99,
    value: "BASIC",
  },
};

export { pricingTier as default, pricing2025 };
